var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketLaunch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85156 14.9456C6.96094 17.594 3.42969 17.594 3.42969 17.594C3.42969 17.594 3.42969 14.0627 6.07813 13.1721",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 8.75806L10.5 14.0627L6.96094 10.5237L12.2656 5.21899C14.2734 3.21118 16.2812 3.23462 17.1406 3.35962C17.2732 3.37731 17.3963 3.43815 17.4909 3.53275C17.5855 3.62735 17.6464 3.75045 17.6641 3.88306C17.7891 4.74243 17.8125 6.75024 15.8047 8.75806Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 9.64087V14.6877C14.9195 14.8526 14.8521 15.0098 14.7344 15.1252L12.2109 17.6565C12.1309 17.7365 12.0306 17.7932 11.9208 17.8206C11.8111 17.8481 11.6959 17.8452 11.5876 17.8123C11.4794 17.7794 11.382 17.7178 11.3061 17.6339C11.2301 17.5501 11.1783 17.4472 11.1562 17.3362L10.5 14.0627",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3828 6.10181H6.33594C6.17109 6.10415 6.01384 6.17155 5.89844 6.28931L3.36719 8.81274C3.28723 8.8928 3.23049 8.99307 3.20305 9.10284C3.1756 9.21262 3.17848 9.32778 3.21136 9.43605C3.24424 9.54433 3.3059 9.64164 3.38976 9.71761C3.47361 9.79358 3.57652 9.84536 3.6875 9.86743L6.96094 10.5237",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch2);
export default __webpack_public_path__ + "static/media/RocketLaunch2.54ea3fd4c0dbd1ae8c621b5dc01018d3.svg";
export { ForwardRef as ReactComponent };